import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { useGLTF } from "@react-three/drei";
import { animated } from "@react-spring/three";
import NeptuneParticles from "./NeptuneParticles";

export default function Earth({ position=[0,0,0], rotation=[0,0,0], scale=1, showParticles=true, animate=true, animateSpeed=0.5 }) {
  const { nodes, materials } = useGLTF("/models/earth-round.glb");

  const earth = useRef();

  useFrame((state) => {
    if (animate)
      earth.current.rotation.y = state.clock.elapsedTime * animateSpeed;
  });

  return (
    <animated.group ref={earth} position={position} rotation={rotation} scale={scale}>
      <group rotation={[Math.PI/3, -Math.PI/2, 0]}>
      {/* <group ref={earth} rotation={[Math.PI / 16, Math.PI / 4, 0]}> */}
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.low_poly_earth.geometry}
          material={materials.water}
          position={[0, 0.12, 0]}
          rotation={[-0.4, -0.4, 0.3]}
        >
          {/* <mesh
            name='flag'
            castShadow
            receiveShadow
            geometry={nodes.Cylinder.geometry}
            material={materials["Material.001"]}
            position={[1.1, 0.98, 0.38]}
            rotation={[0.49, 0.02, 0.39]}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Plane.geometry}
              material={materials.Material}
              position={[0.24, 1.29, 0]}
              scale={0.77}
            />
          </mesh> */}
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh.geometry}
            material={materials.water}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh_1.geometry}
            material={materials.earth}
          />
        </mesh>
      </group>
      { showParticles && <NeptuneParticles/> }
    </animated.group>
  );
}